import { FETCH_ORDER_DETAILS_REQUEST, FETCH_ORDER_DETAILS_SUCCESS, FETCH_ORDER_DETAILS_ERROR } from '../constants/ActionTypes'

export default function isFetchingOrderDetails(state = false, action) {
    switch (action.type) {
        case FETCH_ORDER_DETAILS_REQUEST:
            return true
        case FETCH_ORDER_DETAILS_SUCCESS:
        case FETCH_ORDER_DETAILS_ERROR:
            return false
        default:
            return state
    }
}
